import React, { useEffect } from "react";
import PropTypes from "prop-types";

const SpinnerWithButton = ({
  spinnerClass,
  onClick,
  btnLabel,
  spinnerTypeClass,
  spinnerSizeClass,
}) => {
  return (
    <>
    <div className={ `library-spinner ${spinnerClass}`}>
     <button className="btn" type="button" onClick={(event) => onClick(event)}>
       <span className={`${spinnerTypeClass?spinnerTypeClass:"spinner-border"} ${spinnerSizeClass?spinnerSizeClass:"spinner-border-sm"} spinner_custom`} role="status" aria-hidden="true"></span>
        {btnLabel}
      </button>
     {/* <button className="btn" type="button"  onClick={(event) => onClick(event)} >
      <span className={`${spinnerTypeClass?spinnerTypeClass:"spinner-border"} ${spinnerSizeClass?spinnerSizeClass:"spinner-border-sm"}`} role="status" aria-hidden="true"></span>
      <span className="sr-only">Loading...</span>
     </button> */}
    </div>
    </>
  );
};

SpinnerWithButton.prototype = {
  spinnerClass:PropTypes.string,
  onClick: PropTypes.func.isRequired,
  btnLabel:PropTypes.string,
  spinnerTypeClass:PropTypes.string,
  spinnerSizeClass:PropTypes.string,
};

SpinnerWithButton.defaultProps = {
  spinnerClass:"",
  btnLabel:"",
};
export default SpinnerWithButton;
